import { ESignTemplate } from 'src/app/classes/models/esign-template';
import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';

export class ESignProvider extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static FileProperties: (
    | {
        property: keyof ESignProvider;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof ESignProvider;
        type: 'alias';
      }
    | {
        property: keyof ESignProvider;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'name', type: 'column', dataType: 'string' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' }
  ];

  static {
    ESignProvider.FileProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        ESignProvider.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        ESignProvider.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        ESignProvider.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(FileObject: Partial<ESignProvider>) {
    super();

    ESignProvider.FileProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = FileObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  name?: string;
  createdAt?: Date;
  updatedAt?: Date;

  ESignTemplates?: ESignTemplate[];
}
